"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAmazonChatBoxEnabled = checkAmazonChatBoxEnabled;
function checkAmazonChatBoxEnabled(chatKillSwitch, showAllPages, activeChatCookie, liveChatAvailable) {
  if (!chatKillSwitch) {
    return false;
  }
  return showAllPages || !!activeChatCookie || liveChatAvailable;
}